import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Helmet } from "react-helmet";

import { request } from "@/Api";
import { PageTitle } from "@/common/CommonComponents";
import { Heading } from "@/common/typography";
import { ProfileStyle } from "@/profiles_common/profileStyle";
import PersonProfileThumbnail from "./PersonProfileThumbnail";

export default function PersonProfiles() {
    const [personProfiles, setPersonProfiles] = useState(null);
    const getPersonProfiles = () => {
        request.get("person-profiles").then((response) => {
            setPersonProfiles(response.data);
        });
    };
    useEffect(() => {
        getPersonProfiles();
    }, []);

    if (!personProfiles) {
        return null;
    }
    return (
        <ProfileStyle>
            <Helmet>
                <PageTitle title="Talent" />
            </Helmet>

            <Grid container alignItems={"center"} paddingBottom={8}>
                <Heading style={{ marginTop: 13 }}>Talent</Heading>
            </Grid>

            <Grid container spacing={"25px"}>
                {personProfiles.map((personProfile, index) => (
                    <PersonProfileThumbnail
                        key={index}
                        personProfile={personProfile}
                    />
                ))}
            </Grid>
        </ProfileStyle>
    );
}
